module.exports = __webpack_public_path__ + "static/media/big_buck_bunny.5baf40f.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_buck_bunny.webm
// module id = 9G4K
// module chunks = 0